import { suppressedSubBrandsExactMatch } from '../constants/suppressedSubBrandsExactMatch';
import { suppressedSubBrandsContainsLogic } from '../constants/suppressedSubBrandsContainsLogic';

function checkIfSearchTermHasSuppressedSubBrand(pageContext) {

  // cleanses search term by decoding uri components, converting to uppercase,
  // and replacing multiple spaces with single space to ensure consistent matching with suppressed sub-brands from config
  // defaults to empty string if search term is not present in page context
  const cleansedSearchTerm = pageContext?.keyword ? decodeURIComponent(pageContext.keyword).toUpperCase().replace(/\s+/, ' ') : '';

  const doesSearchTermExactlyMatchSuppressedSubBrand = suppressedSubBrandsExactMatch
    .map((suppressedSubBrand) => suppressedSubBrand.toUpperCase())
    .includes(cleansedSearchTerm);

  const doesSearchTermContainSuppressedSubBrand = suppressedSubBrandsContainsLogic.map((suppressedSubBrand) => suppressedSubBrand.toUpperCase()).some((suppressedSubBrand) => {
    let suppressedSubBrandWithSpaces;
    if (cleansedSearchTerm?.startsWith(suppressedSubBrand) && cleansedSearchTerm?.endsWith(suppressedSubBrand)) {
      suppressedSubBrandWithSpaces = `${suppressedSubBrand}`;
    } else if (cleansedSearchTerm?.startsWith(suppressedSubBrand)) {
      suppressedSubBrandWithSpaces = `${suppressedSubBrand} `;
    } else if (cleansedSearchTerm?.endsWith(suppressedSubBrand)) {
      suppressedSubBrandWithSpaces = ` ${suppressedSubBrand}`;
    } else {
      suppressedSubBrandWithSpaces = ` ${suppressedSubBrand} `;
    }

    return cleansedSearchTerm?.includes(suppressedSubBrandWithSpaces);
  });

  return doesSearchTermExactlyMatchSuppressedSubBrand || doesSearchTermContainSuppressedSubBrand;

}

export const shouldSuppressBanner = ({ experienceContext, pageContext, suppressedNValues }) => {
  const { path } = experienceContext;
  const { data } = pageContext;

  // Suppression of banners based of n-values in config service
  const currentNValue = path?.match(/N-[^/?]+/)?.[0];
  const nValueArray = suppressedNValues ? String(suppressedNValues)?.split(',').map((nValue) => nValue.trim()) : [];

  if ((currentNValue && nValueArray.includes(currentNValue))) {
    return true;
  }

  const hasBrandCrumb = data?.searchModel?.taxonomy?.breadCrumbs?.some((crumb) => crumb.dimensionName === 'Brand');
  const isFeaturedProductNode = path?.indexOf('/b/Featured-Products') !== -1;

  const hasBrandSearch = data?.searchModel?.metadata?.analytics?.semanticTokens
    && data.searchModel.metadata.analytics.semanticTokens.indexOf('br:{') !== -1;

  const hasSearchTermWithSuppressedSubBrand = checkIfSearchTermHasSuppressedSubBrand(pageContext);

  return hasBrandCrumb || hasBrandSearch || isFeaturedProductNode || hasSearchTermWithSuppressedSubBrand;
};

// Might want to combine this function with shouldSuppressBanner in the future
export const suppressBannerReason = ({ experienceContext = {},
  pageContext = {},
  suppressedNValues } = {}) => {
  const { path = '' } = experienceContext;
  const { data = {} } = pageContext;

  const suppressionChecks = [
    {
      reason: 'suppression-n-value',
      checkSuppressionReason: () => {
        const currentNValue = path?.match(/N-[^/?]+/)?.[0];
        const nValueArray = suppressedNValues?.split(',').map((n) => n.trim()) || [];
        return currentNValue && nValueArray?.includes(currentNValue);
      }
    },
    {
      reason: 'suppression-brand-crumb',
      checkSuppressionReason: () => data?.searchModel?.taxonomy?.breadCrumbs?.some((crumb) => crumb.dimensionName === 'Brand')
    },
    {
      reason: 'suppression-feature-product',
      checkSuppressionReason: () => path?.includes('/b/Featured-Products')
    },
    {
      reason: 'suppression-brand-search',
      checkSuppressionReason: () => data?.searchModel?.metadata?.analytics?.semanticTokens?.includes('br:{')
    },
    {
      reason: 'suppression-subBrand',
      checkSuppressionReason: () => checkIfSearchTermHasSuppressedSubBrand(pageContext)
    }
  ];

  // Find the first check that passes, return its reason, or default to "not-suppressed"
  return suppressionChecks.find((check) => check.checkSuppressionReason())?.reason || 'not-suppressed';
};